"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zIndex = void 0;

/**
 * Modal z-index.
 */
var modalZIndex = 100;
/**
 * Export `zIndex`.
 */

var zIndex = {
  dateInput: {
    popper: 1000
  },
  dateRangeInput: {
    fang: 1100,
    picker: 1000
  },
  dropdown: {
    button: 10,
    menu: 200
  },
  modal: {
    backdrop: modalZIndex,
    closeButton: modalZIndex + 2,
    container: modalZIndex + 1
  },
  overlay: modalZIndex - 1,
  snackbar: 300,
  tooltip: 90
};
exports.zIndex = zIndex;